import { User } from '@/types';

export const getUserDisplayName = (user?: User | null): string => {
  if (!user) return 'Unknown User';

  if (user.name && user.name.trim().length > 0) {
    return user.name;
  }

  const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
  if (fullName.length > 0) {
    return fullName;
  }

  return user.email || 'Unknown User';
};
